import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { selectUserRole } from '../../../store/user/selector'
import { MainLayout } from '../../../components'

const PrivateMainLayoutRoute = ({ component: Component, authenticated, role, allowedRoles, ...rest }) => {

    return (
        <Route
            {...rest}
            render={(props) => authenticated === true
                ? (allowedRoles && !allowedRoles.includes(role)) ?
                    (
                        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                    )
                    : (
                        <MainLayout {...props} >
                            <Component {...props} />
                        </MainLayout>
                    )
                : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            }
        />
    )
}

PrivateMainLayoutRoute.propTypes = {
    authenticated: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
    authenticated: state.user.authenticated,
    role: selectUserRole(state)
})

export default connect(mapStateToProps)(PrivateMainLayoutRoute)




// WEBPACK FOOTER //
// ./src/components/Router/PrivateMainLayoutRoute/PrivateMainLayoutRoute.js